import { getProduct } from "../../data";
import { formatDate } from "../../utils/admin";
import { StatusBadge } from "../UI";

const statusOptions = [
  "Scheduled",
  "Preparing",
  "Out for Delivery",
  "Delivered",
  "Cancelled",
  "Skipped",
];

const scheduleSummary = (order, schedulesById = {}) => {
  const schedule = order?.scheduleId ? schedulesById[order.scheduleId] : null;
  const frequency =
    order?.frequency ||
    schedule?.frequency ||
    (order?.recurring ? "Recurring" : "One Time");
  const days =
    Array.isArray(order?.days) && order.days.length
      ? order.days
      : schedule?.days;
  return {
    frequency,
    days: Array.isArray(days) && days.length ? days.join(", ") : "One time",
  };
};

export default function OrderTable({
  orders,
  usersById,
  addressesById,
  schedulesById = {},
  onStatusChange,
  empty = "No orders found.",
}) {
  if (!orders.length)
    return (
      <div className="admin-empty">
        <i className="fa-solid fa-box-open" />
        <strong>{empty}</strong>
        <span>New confirmed deliveries will appear here.</span>
      </div>
    );

  return (
    <div className="admin-table-wrap">
      <table className="admin-table">
        <thead>
          <tr>
            <th>Customer</th>
            <th>Delivery</th>
            <th>Schedule</th>
            <th>Product</th>
            <th>Selected fruits</th>
            <th>Qty</th>
            <th>Address</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => {
            const user = usersById[order.userId];
            const address = addressesById[order.addressId];
            const product = getProduct(order.productId);
            const pattern = scheduleSummary(order, schedulesById);
            const isFruitBasket = order.type === "fruit_basket" || product?.type === "fruit_basket";
            const selectedFoods = Array.isArray(order.selectedFoods) && order.selectedFoods.length
              ? order.selectedFoods
              : Array.isArray(schedulesById[order.scheduleId]?.selectedFoods)
                ? schedulesById[order.scheduleId].selectedFoods
                : [];
            return (
              <tr key={order.id}>
                <td>
                  <strong>
                    {user?.name || order.customerName || "Unknown customer"}
                  </strong>
                  <small>
                    {user?.mobile || order.customerMobile || user?.email || "—"}
                  </small>
                </td>
                <td>
                  <strong>
                    {formatDate(order.deliveryDate || order.fullDate)}
                  </strong>
                  <small>
                    {order.timeSlot || order.deliveryTimeSlot || "—"}
                  </small>
                </td>
                <td>
                  <strong>{pattern.frequency}</strong>
                  <small>{pattern.days}</small>
                </td>
                <td>
                  <strong>
                    {product?.name ||
                      order.productName ||
                      order.productId ||
                      "—"}
                  </strong>
                  <small>
                    {isFruitBasket ? "Fresh fruits" : "Natural shake"}
                  </small>
                </td>
                <td>
                  {isFruitBasket ? (
                    selectedFoods.length ? (
                      <div className="admin-selected-foods">
                        {selectedFoods.map((food) => (
                          <span className="admin-selected-food" key={food}>{food}</span>
                        ))}
                      </div>
                    ) : <small>Not recorded</small>
                  ) : <small>—</small>}
                </td>
                <td>{order.quantity || 1}</td>
                <td>
                  <strong>{address?.area || order.addressArea || "—"}</strong>
                  <small>{address?.line || order.addressLine || "Pune"}</small>
                </td>
                <td>
                  <select
                    className="admin-status-select"
                    value={order.status || "Scheduled"}
                    onChange={(e) => onStatusChange?.(order.id, e.target.value)}
                  >
                    {statusOptions.map((status) => (
                      <option key={status}>{status}</option>
                    ))}
                  </select>
                  <div className="mt-1">
                    <StatusBadge status={order.status || "Scheduled"} />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
